import { BEHAVIOR_CLICKTHRU_TYPES, DISPLAY_TYPE_BUTTON, DISPLAY_TYPE_ICON } from '../../constants';

export function getDisplayType(behaviorType) {
  if (BEHAVIOR_CLICKTHRU_TYPES.includes(behaviorType)) {
    return DISPLAY_TYPE_ICON;
  }

  return DISPLAY_TYPE_BUTTON;
}
